<template>
  <div>
    <tooltip label="View" type="default" placement="left">
      <a class="button button-table is-small" @click="url()">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
    <tooltip label="Refresh Service" type="default" placement="left" v-if="parseInt($store.state.config.user.level) < 99">
      <a class="button button-table is-small" @click="refresh()">
        <i class="fa fa-refresh"></i>
      </a>
    </tooltip>
    <tooltip label="Skip Debit/Credit" type="default" placement="left" v-if="(parseInt(this.data.skip_client) == 0 || parseInt(this.data.skip_provider) == 0)">
      <a class="button button-table is-small" @click="skip(this.data)">
        <i class="fa fa-arrow-right"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../utils/message'
  import DebitsCredits from '../finances/debitsCredits'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      url () {
        window.open('#/services/service/' + this.data.id)
      },
      skip () {
        let propsData = {
          context: this,
          financial: this.data,
          callback: 'skipDebitsCreditsCallback'
        }
        DebitsCredits.openSkipDebitsCredits(propsData)
      },
      skipDebitsCreditsCallback (result) {
        this.$parent.loadData(true)
      },
      refresh () {
        let service = ''
        if (parseInt(this.data.integration) === 1) {
          service = this.data.service_id
        } else {
          service = this.data.api_service_id
        }
        this.$http.post(this.$store.state.config.apiURL + '/services/refresh', {booking_id: this.data.booking_id}).then((response) => {
          this.message('success', 'Success', 'The service ' + service + ' was successfully refresh')
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    }
  }
</script>

<style lang="scss">
  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// DebitsCreditsTableButtons.vue?c7da4eac